import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_COMUNICACAO_E_ENDOMARKETING: MapaCargo = 
{
  id: 'analista-de-comunicacao-e-endomarketing',
  titulo: 'Analista de Comunicação e Endomarketing',
  setor: 'Gestão / RH',
  secoes: [
    {
      id: 'responsabilidades',
      titulo: 'Responsabilidades',
      atividades: [
        'Responsável pelo planejamento, execução e acompanhamento das estratégias de comunicação interna, endomarketing, fortalecimento da cultura organizacional e posicionamento institucional da empresa, promovendo o engajamento dos colaboradores, fortalecendo a marca empregadora e contribuindo para a visibilidade da agência no mercado.',
      ],
    },
    {
      id: 'comunicacao-interna',
      titulo: 'Comunicação Interna',
      atividades: [
        'Planejar e executar ações de comunicação voltadas aos colaboradores da empresa.',
        'Produzir comunicados, informativos, apresentações e materiais institucionais internos.',
        'Garantir que informações estratégicas sejam disseminadas de forma clara, organizada e eficiente entre as equipes.',
        'Apoiar a liderança na comunicação de mudanças, processos, metas e iniciativas corporativas.',
        'Gerenciar e manter atualizados os canais internos de comunicação.',
      ],
    },
    {
      id: 'endomarketing-e-engajamento',
      titulo: 'Endomarketing e Engajamento',
      atividades: [
        'Desenvolver campanhas internas voltadas ao engajamento, reconhecimento e fortalecimento da cultura organizacional.',
        'Planejar e executar ações comemorativas, campanhas temáticas e iniciativas de integração entre equipes.',
        'Apoiar programas de reconhecimento e valorização dos colaboradores.',
        'Criar iniciativas que fortaleçam o senso de pertencimento e a experiência dos colaboradores.',
        'Apoiar ações voltadas à retenção de talentos e fortalecimento da marca empregadora.',
      ],
    },
    {
      id: 'cultura-organizacional',
      titulo: 'Cultura Organizacional',
      atividades: [
        'Atuar na disseminação dos valores, propósito e cultura da empresa.',
        'Apoiar projetos relacionados à experiência e jornada do colaborador.',
        'Identificar oportunidades de melhoria no clima organizacional e propor ações de desenvolvimento.',
        'Auxiliar na aplicação, análise e acompanhamento de pesquisas de clima, satisfação e engajamento.',
        'Contribuir para a construção de um ambiente organizacional colaborativo e alinhado aos objetivos da empresa.',
      ],
    },
    {
      id: 'planejamento-e-producao-de-conteudo-institucional',
      titulo: 'Planejamento e Produção de Conteúdo Institucional',
      atividades: [
        'Planejar e executar o calendário editorial dos canais institucionais da empresa.',
        'Produzir conteúdos para redes sociais, blog, newsletter, e-mail marketing e demais canais de comunicação institucional.',
        'Desenvolver pautas, roteiros, textos, legendas, apresentações e materiais institucionais.',
        'Identificar oportunidades para divulgação de cases, eventos, bastidores, conquistas e iniciativas da empresa.',
        'Trabalhar em conjunto com o time de criação na produção de materiais visuais e audiovisuais.',
        'Garantir o alinhamento da comunicação institucional com o posicionamento estratégico da marca.',
        'Monitorar métricas e resultados dos canais institucionais, propondo melhorias contínuas.',
      ],
    },
    {
      id: 'eventos-e-relacionamento-institucional',
      titulo: 'Eventos e Relacionamento Institucional',
      atividades: [
        'Planejar, organizar e apoiar a participação da empresa em eventos externos, feiras, congressos, workshops, palestras e ações de relacionamento.',
        'Coordenar a logística necessária para participação da empresa em eventos presenciais e online.',
        'Apoiar a produção de materiais institucionais, brindes e ativações para eventos.',
        'Realizar cobertura de eventos para produção de conteúdo institucional e fortalecimento da marca.',
        'Atuar no relacionamento com parceiros, fornecedores e organizadores de eventos quando necessário.',
        'Identificar oportunidades de participação da empresa em iniciativas que fortaleçam o posicionamento institucional e a geração de networking.',
      ],
    },
    {
      id: 'eventos-internos-e-experiencia-do-colaborador',
      titulo: 'Eventos Internos e Experiência do Colaborador',
      atividades: [
        'Planejar e apoiar a execução de eventos corporativos, treinamentos, convenções, encontros internos e ações de integração.',
        'Organizar ações de onboarding e acolhimento de novos colaboradores.',
        'Apoiar iniciativas voltadas ao desenvolvimento da jornada e experiência do colaborador.',
        'Auxiliar na execução de campanhas internas relacionadas à saúde, bem-estar e qualidade de vida.',
      ],
    },
    {
      id: 'gestao-de-projetos-e-fornecedores',
      titulo: 'Gestão de Projetos e Fornecedores',
      atividades: [
        'Planejar e acompanhar cronogramas relacionados às ações de comunicação interna, endomarketing e eventos.',
        'Realizar orçamentos e acompanhar fornecedores para produção de materiais, brindes, eventos e demais iniciativas institucionais.',
        'Garantir o cumprimento de prazos, qualidade das entregas e alinhamento com os objetivos da empresa.',
        'Apoiar o controle de investimentos e recursos destinados às ações internas e institucionais.',
        'Organizar demandas, fluxos de trabalho e processos relacionados aos projetos sob sua responsabilidade.',
      ],
    },
    {
      id: 'planejamento-estrategico',
      titulo: 'Planejamento Estratégico',
      atividades: [
        'Participar da construção e execução do planejamento anual de comunicação interna, endomarketing e marca empregadora.',
        'Planejar campanhas institucionais alinhadas aos objetivos estratégicos da empresa.',
        'Apoiar a organização do calendário anual de ações e eventos internos e externos.',
        'Sugerir novas iniciativas e projetos voltados ao fortalecimento da cultura organizacional e da marca.',
      ],
    },
    {
      id: 'indicadores-e-gestao',
      titulo: 'Indicadores e Gestão',
      atividades: [
        'Acompanhar indicadores de engajamento e participação em ações internas.',
        'Elaborar relatórios e análises sobre campanhas, eventos e iniciativas de comunicação.',
        'Monitorar resultados de pesquisas internas e apoiar a construção de planos de ação.',
        'Avaliar resultados dos canais institucionais e propor melhorias de desempenho.',
      ],
    },
  ],
}
